import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children, className = "" }) => (
  <span className={`font-mono-label inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] ${className}`}>
    <span className="h-2 w-2 rounded-full bg-[var(--red)]" />
    {children}
  </span>
);

export const Star = ({ className = "", fill = "var(--yellow)" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path
      d="M12 2.5l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.3l-5.8 3.1 1.1-6.5L2.6 9.3l6.5-.9z"
      fill={fill}
      stroke="#fff"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const Note = ({ className = "", fill = "var(--blue)" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path d="M9 18.5a3 3 0 1 1-2-2.83V5l12-2.5v12a3 3 0 1 1-2-2.83V6.6L9 8.2z" fill={fill} stroke="#fff" strokeWidth="1.6" strokeLinejoin="round" />
  </svg>
);
